import { ApiHttpService } from "../../../shared/services/api-http.service";
import { LoadingWrapperService } from "../../../shared/services/loading-wrapper.service";
import { FormControl, FormGroup, FormBuilder, Validators } from "@angular/forms";
import { FileSaverService } from "../../../shared/services/file-saver.service";
import { finalize } from "rxjs/operators";
import { ExperimentDesignFormValidatorsService } from "../experiment-design-form/experiment-design-form-validators.service";
var SeedNeedsUploadComponent = /** @class */ (function () {
    function SeedNeedsUploadComponent(httpService, fileSaverService, loadingService, formBuilder, formValidators) {
        this.httpService = httpService;
        this.fileSaverService = fileSaverService;
        this.loadingService = loadingService;
        this.formBuilder = formBuilder;
        this.formValidators = formValidators;
        this.allContainColorMarkers = new FormControl(false);
        this.errors = [];
    }
    Object.defineProperty(SeedNeedsUploadComponent.prototype, "seedNeeds", {
        get: function () {
            return this.experimentDesignFormGroup.get("seedNeeds");
        },
        enumerable: true,
        configurable: true
    });
    SeedNeedsUploadComponent.prototype.upload = function (files) {
        var _this = this;
        this.loadingService.setMessage("Loading...");
        var criteria = {
            cropId: this.crop
        };
        if (files.length === 0 || files.length > 1)
            return;
        var formData = new FormData();
        formData.append(files[0].name, files[0]);
        formData.append("validationCriteria", JSON.stringify(criteria));
        this.httpService.post("seedneedsupload", formData)
            .pipe(finalize(function () { return _this.loadingService.clearMessage(); }))
            .subscribe(function (entries) {
            _this.experimentDesignFormGroup.setControl("seedNeeds", _this.buildSeedNeedsArray(entries));
            _this.updateNumberOfSeedsToStart();
            _this.errors = [];
            _this.allContainColorMarkers.setValue(false);
        }, function (err) {
            if (err.status === 400) {
                _this.errors = _this.formatErrorMessages(err.error);
                _this.experimentDesignFormGroup.setControl("seedNeeds", _this.formBuilder.array([]));
            }
            else {
                throw err;
            }
        });
    };
    SeedNeedsUploadComponent.prototype.downloadTemplate = function () {
        var _this = this;
        this.httpService.get("seedneedstemplate").subscribe(function (f) {
            _this.fileSaverService.save(f);
        });
    };
    SeedNeedsUploadComponent.prototype.copyDown = function () {
        var firstTreatmentArray = this.seedNeeds.at(0).get("treatments").value;
        for (var i = 1; i < this.seedNeeds.length; i++) {
            var treatmentArray = this.seedNeeds.at(i).get("treatments");
            for (var j = 0; j < treatmentArray.length; j++) {
                treatmentArray.at(j).get("seedCount").patchValue(firstTreatmentArray[j].seedCount);
            }
        }
    };
    SeedNeedsUploadComponent.prototype.buildSeedNeedsArray = function (entries) {
        var _this = this;
        var seedNeedsArray = this.formBuilder.array([]);
        for (var i = 0; i < entries.length; i++) {
            var entry = entries[i];
            var treatmentArray = this.formBuilder.array([]);
            for (var t = 0; t < this.treatmentCount; t++) {
                var seedCount = this.formBuilder
                    .control({ value: this.treatmentCount === 1 ? entry.numberOfSeeds : 0, disabled: false }, [Validators.min(0)]);
                treatmentArray.push(this.formBuilder.group({
                    treatmentNumber: this.formBuilder.control({ value: t + 1, disabled: false }),
                    seedCount: seedCount
                }));
                seedCount.valueChanges.subscribe(function (c) {
                    _this.updateNumberOfSeedsToStart();
                });
            }
            seedNeedsArray.push(this.formBuilder.group({
                entryNumber: this.formBuilder.control({ value: entry.entryNumber, disabled: false }),
                siid: this.formBuilder.control({ value: entry.siid, disabled: false }),
                geName: this.formBuilder.control({ value: entry.geName, disabled: false }),
                numberOfSeeds: this.formBuilder.control({ value: entry.numberOfSeeds, disabled: false }),
                treatments: treatmentArray
            }, { validator: this.formValidators.seedCountValidator() }));
        }
        return seedNeedsArray;
    };
    SeedNeedsUploadComponent.prototype.formatErrorMessages = function (errors) {
        var errorMessages = [];
        errorMessages.push.apply(errorMessages, errors.fileErrors);
        errors.entryErrors.forEach(function (entryError) {
            errorMessages.push("Line: " + entryError.lineNumber + ". SIID: " + entryError.siid + ". " + entryError.error);
        });
        return errorMessages;
    };
    SeedNeedsUploadComponent.prototype.updateNumberOfSeedsToStart = function () {
        var numTreatments = this.experimentDesignFormGroup.get("treatments").length;
        for (var i = 0; i < numTreatments; i++) {
            var treatment = this.experimentDesignFormGroup.get("treatments").at(i);
            var plantingInstructions = treatment.get("plantingInstructions");
            var numberToStart = plantingInstructions.get("numberToStart");
            var numberOfSeedsPerCellControl = this.experimentDesignFormGroup.get('numberOfSeedsPerCell');
            var numberToStartTotal = 0;
            var numberOfEuids = 0;
            var seedNeeds = this.experimentDesignFormGroup.get("seedNeeds");
            for (var _i = 0, _a = seedNeeds.controls; _i < _a.length; _i++) {
                var seedNeed = _a[_i];
                var seedNeedsTreatment = seedNeed.get("treatments").at(i);
                numberToStartTotal += seedNeedsTreatment.get("seedCount").value;
                numberOfEuids += Math.ceil(seedNeedsTreatment.get("seedCount").value / numberOfSeedsPerCellControl.value);
            }
            numberToStart.patchValue(numberToStartTotal);
            plantingInstructions.clearValidators();
            plantingInstructions.setValidators(this.formValidators.plantingInstructionsValidator(numberOfEuids));
            plantingInstructions.updateValueAndValidity();
        }
    };
    return SeedNeedsUploadComponent;
}());
export { SeedNeedsUploadComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/seed-needs-upload/seed-needs-upload.component.ts.pre-build-optimizer.js